module.exports = __webpack_public_path__ + "static/img/BK5.f39d458.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/BK5.png
// module id = iABN
// module chunks = 9